import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const AccessDenied = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center rounded-[12px] p-10">
      <div className="bg-red-100 p-6 rounded-full mb-6">
        <FontAwesomeIcon icon={faLock} className="text-red-500 text-5xl" />
      </div>
      <h2 className="font-Inter font-bold text-3xl text-gray-800 mb-2">
        Access Restricted
      </h2>
      <p className="font-Inter text-gray-500 max-w-md mb-8">
        You do not have permission to view this screen. 
        Please contact your administrator to request access.
      </p>
      <Link 
        to="/" 
        className="px-6 py-3 bg-[#17171B] text-white rounded-[8px] font-Inter hover:bg-gray-800 transition-colors"
      >
        Go to Dashboard
      </Link>
    </div>
  );
};

export default AccessDenied;